export const genderOptions = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
];

export const languageOptions = [
  { value: 'english', label: 'English' },
  { value: 'hindi', label: 'Hindi' },
  { value: 'telugu', label: 'Telugu' },
  { value: 'tamil', label: 'Tamil' },
  { value: 'kannada', label: 'Kannada' },
  { value: 'gujarati', label: 'Gujarati' },
  { value: 'punjabi', label: 'Punjabi' },
  { value: 'marathi', label: 'Marathi' },
  { value: 'bengali', label: 'Bengali' },
  { value: 'malayalam', label: 'Malayalam' },
];

export const idOptions = [
  { value: 'aadhaar', label: 'Aadhaar' },
  { value: 'driving_license', label: 'Driving License' },
  { value: 'pan', label: 'PAN' },
  { value: 'passport', label: 'Passport' },
  { value: 'ration_card', label: 'Ration Card' },
  { value: 'voter_id', label: 'Voter ID' },
];

export const hobbiesOptions = [
  { value: 'ACTING_DRAMA', label: 'Acting / Drama' },
  { value: 'ASTRONOMY', label: 'Astronomy' },
  { value: 'BADMINTON', label: 'Badminton' },
  { value: 'BAKING', label: 'Baking' },
  { value: 'BLOGGING', label: 'Blogging' },
  { value: 'BOARD_GAMES', label: 'Board Games' },
  { value: 'BODY_BUILDING', label: 'Body Building' },
  { value: 'CAR_RACING', label: 'Car Racing' },
  { value: 'CARPENTRY', label: 'Carpentry' },
  { value: 'CHESS', label: 'Chess' },
  { value: 'COOKING', label: 'Cooking' },
  { value: 'CRICKET', label: 'Cricket' },
  { value: 'DRAWING', label: 'Drawing' },
  { value: 'EMBROIDERY', label: 'Embroidery' },
  { value: 'FOOTBALL', label: 'Football' },
  { value: 'GARDENING', label: 'Gardening' },
  { value: 'GOLF', label: 'Golf' },
  { value: 'HIKING', label: 'Hiking' },
  { value: 'HUNTING', label: 'Hunting' },
  { value: 'ICE_SKATING', label: 'Ice Skating' },
  { value: 'JOGGING', label: 'Jogging' },
  { value: 'LISTENING_TO_MUSIC', label: 'Listening to Music' },
  { value: 'LONG_DRIVES', label: 'Long Drives' },
  { value: 'MARTIAL_ART', label: 'Martial Art' },
  { value: 'MEDITATION', label: 'Meditation' },
  { value: 'MOVIES', label: 'Movies' },
  { value: 'NAIL_ART', label: 'Nail Art' },
  { value: 'ORIGAMI', label: 'Origami' },
  { value: 'PAINTING', label: 'Painting' },
  { value: 'PHOTOGRAPHY', label: 'Photography' },
  { value: 'PLAYING_VIDEO_GAMES', label: 'Playing Video Games' },
  { value: 'POLO', label: 'Polo' },
  { value: 'PODCASTING', label: 'Podcasting' },
  { value: 'READING', label: 'Reading' },
  { value: 'RESEARCH', label: 'Research' },
  { value: 'RIDING', label: 'Riding' },
  { value: 'RIVER_RAFTING', label: 'River Rafting' },
  { value: 'RUNNING', label: 'Running' },
  { value: 'SHOOTING', label: 'Shooting' },
  { value: 'SHOPPING', label: 'Shopping' },
  { value: 'SINGING', label: 'Singing' },
  { value: 'SKATING', label: 'Skating' },
  { value: 'SUDOKU', label: 'Sudoku' },
  { value: 'SWIMMING', label: 'Swimming' },
  { value: 'TABLE_TENNIS', label: 'Table Tennis' },
  { value: 'TENNIS', label: 'Tennis' },
  { value: 'THEATER', label: 'Theater' },
  { value: 'TREKKING', label: 'Trekking' },
  { value: 'WATER_POLO', label: 'Water Polo' },
  { value: 'WRESTLING', label: 'Wrestling' },
  { value: 'YOGA', label: 'Yoga' },
];

export const countryOptions = [{ value: 'india', label: 'India' }];

export const cityOptions = [
  { value: 'mumbai', label: 'Mumbai' },
  { value: 'pune', label: 'Pune' },
  { value: 'bangalore', label: 'Bangalore' },
  { value: 'chennai', label: 'Chennai' },
  { value: 'hyderabad', label: 'Hyderabad' },
];

export const stateOptions = [
  { value: 'maharashtra', label: 'Maharashtra' },
  { value: 'karnataka', label: 'Karnataka' },
  { value: 'tamil Nadu', label: 'Tamil Nadu' },
  { value: 'kerala', label: 'Kerala' },
];

export const licenseTypeOptions = [
  { value: 'sales_person', label: 'Sales Person' },
  { value: 'broker', label: 'Broker' },
  // { value: 'individual', label: 'Individual' },
  // { value: 'agency', label: 'Agency' },
  // { value: 'franchise', label: 'Franchise' },
  // { value: 'commercial', label: 'Commercial' },
  // { value: 'residential', label: 'Residential' },
  // { value: 'property_management', label: 'Property Management' },
  // { value: 'referral', label: 'Referral' },
  // { value: 'trainee', label: 'Trainee' },
];
export const previousRoleOptions = [
  { value: 'salebroker', label: 'Sale Broker' },
  { value: 'listingbroker', label: 'Listing Broker' },
  { value: 'deskbroker', label: 'Desk Broker' },
];
export const designationOptions = [
  { value: 'owner', label: 'Owner' },
  { value: 'manager', label: 'Manager' },
  { value: 'associate', label: 'Associate' },
  { value: 'executive', label: 'Executive' },
  { value: 'partner', label: 'Partner' },
];
export const specializationOptions = [
  { value: 'residential_sale', label: 'Residential Selling' },
  { value: 'residential_rent', label: 'Residential Renting' },
  { value: 'commercial_sale', label: 'Commercial Selling' },
  { value: 'commercial_rent', label: 'Commercial Renting' },
  { value: 'commercial_sale_and_rent', label: 'Commercial Sale and Rent' },
  { value: 'residential_sale_and_rent', label: 'Residential Sale and Rent' },
];
export const propertyTypeOptions = [
  { value: 'RESIDENTIAL', label: 'Residential' },
  { value: 'COMMERCIAL', label: 'Commercial' },
];
export const subTypeOptions = [
  { value: 'FLAT', label: 'Flat' },
  { value: 'APARTMENT', label: 'Apartment' },
  { value: 'VILLA', label: 'Villa' },
  { value: 'PENTHOUSE', label: 'Penthouse' },
  { value: 'INDEPENDENT_HOUSE', label: 'Independent House' },
  { value: 'OTHER', label: 'Other' },
];
export const transactionTypeOptions = [
  { value: 'outrightSale', label: 'Outright Sale' },
  { value: 'leaseRent', label: ' Lease/ Rent ' },
  { value: 'jointDevelopment', label: 'Joint Development' },
  { value: 'landAggregation', label: 'Land Aggregation ' },
  { value: 'assignmentTransfer', label: 'Assignment / Transfer of rights' },
  { value: 'distressSale', label: ' Distress Sale' },
  { value: 'auction', label: 'Auction ' },
  { value: 'preLaunch', label: ' Pre Launch' },
  { value: 'institutionalSale', label: 'Institutional Sale/ Bulk Sale' },
  { value: 'fractionalOwnership', label: 'Fractional Ownership ' },
  { value: 'exchangeSwap', label: ' Exchange / Swap' },
  { value: 'powerOfAttorney', label: 'Power of Attorney' },
  { value: 'governmentAllotment', label: 'Government Allotment' },
];

export const propertyStatusOptions = [
  { value: 'READY_TO_MOVE', label: 'Ready to Move' },
  { value: 'UNDER_CONSTRUCTION', label: 'Under Construction' },
  { value: 'NEWLY_COMPLETED', label: 'Newly Completed' },
  { value: 'OTHER', label: 'Other' },
];
export const furnishingStatusOptions = [
  { value: 'FURNISHED', label: 'Furnished' },
  { value: 'SEMI_FURNISHED', label: 'Semi Furnished' },
  { value: 'UNFURNISHED', label: 'Unfurnished' },
];
export const possessionTimeOptions = [
  { value: 'immediately', label: 'Immediately' },
  { value: 'after3months', label: 'After 3 Months' },
  { value: 'after6months', label: 'After 6 Months' },
  { value: 'after1year', label: 'After 1 Year' },
];
export const bhkOptions = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
];
export const totalRoomsOptions = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
];
export const ownershipTypeOptions = [
  { value: 'SELF', label: 'Self' },
  { value: 'FREE_HOLD', label: 'Free Hold' },
  { value: 'LEASE_HOLD', label: 'Lease Hold' },
  { value: 'JOINT_OWNERSHIP', label: 'Joint Ownership' },
  { value: 'INHERITED', label: 'Inherited' },
  { value: 'OTHER', label: 'Other' },
];
export const brokerOptions = [
  { value: 'salebroker', label: 'Sale Broker' },
  { value: 'listingbroker', label: 'Listing Broker' },
  { value: 'deskbroker', label: 'Desk Broker' },
];
export const developerOptions = [
  { value: 'developer1', label: 'Developer 1' },
  { value: 'developer2', label: 'Developer 2' },
  { value: 'developer3', label: 'Developer 3' },
  { value: 'ABC Developers Pvt Ltd', label: 'ABC Developers Pvt Ltd' },
  { value: 'Pacific', label: 'Pacific' },
];
export const projectOptions = [
  { value: 'project1', label: 'Project 1' },
  { value: 'project2', label: 'Project 2' },
  { value: 'project3', label: 'Project 3' },
  { value: 'Green Valley Apartments', label: 'Green Valley Apartments' },
  { value: 'ReUnited', label: 'ReUnited' },
];
export const areaOptions = [
  { value: 'area1', label: 'Area 1' },
  { value: 'area2', label: 'Area 2' },
  { value: 'area3', label: 'Area 3' },
];
export const contractTypeOptions = [
  { value: 'agreementToSell', label: 'Agreement to Sell' },
  { value: 'leaseRentAgreement', label: 'Lease/ Rent Agreement' },
  { value: 'leaveLicenseAgreement', label: 'Leave & License Agreement' },
  { value: 'allotmentLetter', label: ' Allotment letter ' },
  { value: 'powerOfAttorney', label: 'Power of Attorney' },
  { value: 'assignmentAgreement', label: ' Assignment Agreement' },
  { value: 'optionToPurchaseAgreement', label: ' Option to Purchase Agreement' },
  { value: 'releaseRelinquishmentAgreement', label: 'Release/ Relinquishment Agreement' },
  { value: 'giftDeed', label: 'Gift Deed' },
  { value: 'mortgageDeedAgreement', label: 'Mortgage Deed/ Agreement' },
];

export const buildingClassCommercialOptions = [
  { value: 'gradeAOffice', label: 'Grade A Office' },
  { value: 'gradeBOffice', label: 'Grade B Office' },
  { value: 'gradeCOffice', label: 'Grade C Office' },
  { value: 'gradeDOffice', label: 'Co-working / Managed Office' },
  { value: 'retail', label: 'Retail' },
  { value: 'highStreetRetail', label: 'High Street Retail' },
  { value: 'mallRetailGradeA', label: 'Mall Retail- Grade A' },
  { value: 'mallRetailGradeB', label: 'Mall Retail- Grade B' },
  { value: 'mallRetailGradeC', label: 'Mall Retail- Grade C' },
  { value: 'standaloneShop', label: 'Standalone Shop' },
];

export const buildingClassResidentialOptions = [
  { value: 'luxury', label: 'Luxury' },
  { value: 'midSegment', label: 'Mid-Segment' },
  { value: 'affordable', label: 'Affordable' },
  { value: 'ultraLuxury', label: 'Ultra-Luxury' },
  { value: 'servicedApartments', label: 'Serviced Apartments' },
  { value: 'industrialWarehouse', label: 'Industrial / Warehouse' },
  { value: 'gradeAWarehouse', label: 'Grade A Warehouse' },
  { value: 'gradeBWarehouse', label: 'Grade B Warehouse' },
  { value: 'gradeCWarehouse', label: 'Grade C Warehouse' },
  { value: 'logisticsParkUnit', label: 'Logistics Park Unit' },
  { value: 'mixedUse', label: 'Mixed Use' },
  { value: 'fullyMixedUse', label: 'Fully Mixed-Use' },
  { value: 'commercialMixedUse', label: 'Commercial Mixed-Use' },
];

export const facingDirectionOptions = [
  { value: 'north', label: 'North' },
  { value: 'south', label: 'South' },
  { value: 'east', label: 'East' },
  { value: 'west', label: 'West' },
  { value: 'northeast', label: 'North-East(NE)' },
  { value: 'northwest', label: 'North-West(NW)' },
  { value: 'southeast', label: 'South-East(SE)' },
  { value: 'southwest', label: 'South-West(SW)' },
];

export const leaseTypeOptions = [
  { value: 'fixedTermLease', label: ' Fixed Term Lease' },
  { value: 'longTermLease', label: 'Long Term Lease' },
  { value: 'monthToMonthLease', label: 'Month to Month Lease' },
  { value: 'tripleNetLease', label: 'Triple Net Lease - Rent, maintenance, insurance' },
  { value: 'grossLease', label: 'Double net lease: Rent, Maintenance' },
  { value: 'singleNetLease', label: ' Rent only lease' },
  { value: 'fullServiceLease', label: 'Full Service Lease - Rent, Maintennace, Housekeeping, Insurance, Electricity' },
  { value: 'leaseWithFitoutContribution', label: 'Lease with Fitout contribution' },
  { value: 'coWorkingSpaceLease', label: 'Co-working space lease' },
];

export const leaseTenureOptions = [
  { value: '11Months', label: '11 Months' },
  { value: '12Months', label: '12 Months' },
  { value: '24Months', label: '24 Months' },
];

export const numberOptions = (count, start = 1) =>
  Array.from({ length: count }, (_, i) => {
    const n = String(start + i);
    return { value: n, label: n };
  });

export const noticeMonthsOptions = numberOptions(12);

export const rentFrequencyOptions = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'quarterly', label: 'Quarterly' },
  { value: 'halfyearly', label: 'Half Yearly' },
  { value: 'annually', label: 'Annually' },
];

export const ageOfPropertyOptions = Array.from({ length: 99 }, (_, i) => {
  const years = i + 1;
  const yearText = years === 1 ? 'year' : 'years';
  const value = `${years} ${yearText}`;
  return {
    label: value,
    value: value.toLowerCase(),
  };
});

export const followUpForOptions = [
  { value: 'New Lead', label: 'New Lead' },
  { value: 'Existing Deals', label: 'Existing Deals' },
  { value: 'Others', label: 'Others' },
];

export const unitPerFloorOptions = Array.from({ length: 20 }, (_, i) => ({
  value: (i + 1).toString(),
  label: `${i + 1}`,
}));

export const SORT_FIELD_MAPPING = {
  doj: 'dateJoined',
  contact: 'phoneNumber',
  salesArea: 'salesAreaCity',
};

export const specializationMapping = {
  residential_selling: 'RESIDENTIAL_SALE',
  residential_rent: 'RESIDENTIAL_RENT',
  commercial_selling: 'COMMERCIAL_SALE',
  commercial_rent: 'COMMERCIAL_RENT',
};
export const typeMapping = {
  firm: 'FIRM',
  individual: 'INDIVIDUAL',
};

export const propertyAvailableForOptions = [
  { value: 'SALE', label: 'Sale' },
  { value: 'RENT', label: 'Rent' },
];
export const buyerTenantTypeOptions = [
  { value: 'FAMILY', label: 'Family' },
  { value: 'BACHELOR_MALE', label: 'Bachelor (Male)' },
  { value: 'BACHELOR_FEMALE', label: 'Bachelor (Female)' },
  { value: 'WORKING_PROFESSIONALS', label: 'Working Professionals' },
  { value: 'STUDENTS', label: 'Students' },
  { value: 'COMPANY_LEASE', label: 'Company Lease' },
  { value: 'ANY', label: 'Any (No Preference)' },
];
